
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[guides]/[...category]",
      function () {
        return require("private-next-pages/[lang]/[guides]/[...category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[guides]/[...category]"])
      });
    }
  